import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconClose } from '@medflex/components/stories/Icons';
import BrandAvatar from '@medflex/components/stories/BrandAvatar';
import Button from '@medflex/components/stories/Button';
import isWebView from '@medflex/utils/isWebView';
import { isAndroid } from '@medflex/utils/mobile';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=de.medflex.app.flutter';

const PlayStoreBannerModule = () => {
  const [hideBanner, setHideBanner] = useState(false);
  const { t } = useTranslation('components');
  // This banner should be displayed only in browser  and only for android devices.
  // It should not be displayed in the mobile app
  // For iOS devices we are using Smart App Banner
  // for more details see https://medflexgmbh.atlassian.net/browse/MMA-193
  const shouldRender = useMemo(() => !isWebView() && !hideBanner && isAndroid(), [hideBanner]);

  if (!shouldRender) {
    return null;
  }

  const goToPlayStore = () => {
    window.open(PLAY_STORE_URL, '_blank');
    setHideBanner(true);
  };

  return (
    <div className="relative w-full bg-slate-100 flex flex-row p-2 items-center justify-between">
      <div className="flex flex-row items-center">
        <IconClose
          size="3"
          className="block mr-2 text-slate-500"
          onClick={() => setHideBanner(true)}
        />
        <div className="bg-white border border-slate-300 rounded-md p-2">
          <BrandAvatar size="8" className="self-end" />
        </div>
        <div className="grow text-sm px-2 leading-4">
          <h3 className="font-bold">{t('PlayStoreBannerModule.title')}</h3>
          <p>{t('PlayStoreBannerModule.subtitle')}</p>
        </div>
      </div>
      <Button
        type="button"
        className="mr-2 px-2 whitespace-no-wrap"
        size="xs"
        onClick={goToPlayStore}
      >
        {t('PlayStoreBannerModule.cta_label')}
      </Button>
    </div>
  );
};

export default PlayStoreBannerModule;
